import { Code2, Check, Copy } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card';
import { RenderPromptDto } from '@/services/PromptsService';

interface PayloadCardProps {
  payload: RenderPromptDto;
  copied: boolean;
  onCopy: () => void;
}

export function PayloadCard({
  payload,
  copied,
  onCopy: handleCopyPayload,
}: PayloadCardProps) {
  const curlCommand = `curl -X 'POST' 'https://catalog.api.fashionai.dev/api/v1/prompts/render' \n -H 'accept: */*' \n -H 'password: ********' \n -H 'Content-Type: application/json' \n -d '${JSON.stringify(payload, null, 2)}'`;

  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0">
        <CardTitle className="text-md flex items-center gap-2">
          <Code2 className="h-4 w-4" />
          Request Payload
        </CardTitle>
        <Button
          variant="outline"
          size="sm"
          onClick={handleCopyPayload}
          className="gap-2 bg-transparent"
        >
          {copied ? (
            <Check className="h-4 w-4" />
          ) : (
            <Copy className="h-4 w-4" />
          )}
          {copied ? 'Copied!' : 'Copy'}
        </Button>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto rounded-md bg-slate-950 p-2 text-slate-50">
          <pre className="text-xs">
            <code>{curlCommand}</code>
          </pre>
        </div>
      </CardContent>
    </Card>
  );
}
